export default __webpack_public_path__ + "static/media/img--kitchen-light.56f702b2.jpg";